import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import type { RootState } from '../store'

import { actionTypes } from './types'

export const name = 'plan'

export type PlanState = {
  //
}

//
// Initial state
//

const initialState: PlanState = {}

//
// Slice (Actions & Reducers)
//

//
// Slice (Actions & Reducers)
//
const slice = createSlice({
  name,
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadPlan: (_state, _action: actionTypes.setPlanId) => {
      //
    },
  },
  extraReducers: {
    [HYDRATE]: (state) => {
      // do not overwrite planning state
      return state
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[name]

export const selectors = {
  root,
}
